/**
 * 游客购物车工具 - 使用 localStorage 存储
 * 未登录状态下的购物车管理
 */

const GUEST_CART_KEY = 'BIZ_GUEST_CART';
const GUEST_INFO_KEY = 'BIZ_GUEST_INFO';
const GUEST_TOKEN_KEY = 'BIZ_GUEST_TOKEN';
const GUEST_LOGIN_EXPIRE_KEY = 'BIZ_GUEST_LOGIN_EXPIRE';

// 15天 = 15 * 24 * 60 * 60 * 1000 毫秒
const LOGIN_EXPIRE_MS = 15 * 24 * 60 * 60 * 1000;

/**
 * 获取游客购物车
 */
export function getGuestCart() {
	try {
		const data = localStorage.getItem(GUEST_CART_KEY);
		return data ? JSON.parse(data) : [];
	} catch (e) {
		return [];
	}
}

/**
 * 保存游客购物车
 */
export function setGuestCart(items) {
	localStorage.setItem(GUEST_CART_KEY, JSON.stringify(items));
}

/**
 * 添加商品到游客购物车
 * @param {Object} product - { skuId, goodsId, goodsName, goodsImage, skuName, price, quantity, storeId, storeName }
 */
export function addToGuestCart(product) {
	const cart = getGuestCart();
	const existIndex = cart.findIndex(item => item.skuId === product.skuId);
	if (existIndex >= 0) {
		cart[existIndex].quantity += (product.quantity || 1);
	} else {
		cart.push({
			...product,
			quantity: product.quantity || 1,
			addedTime: Date.now()
		});
	}
	setGuestCart(cart);
	return cart;
}

/**
 * 修改游客购物车商品数量
 */
export function updateGuestCartQuantity(skuId, quantity) {
	const cart = getGuestCart();
	const item = cart.find(item => item.skuId === skuId);
	if (item) {
		item.quantity = quantity;
		if (quantity <= 0) {
			return removeFromGuestCart(skuId);
		}
		setGuestCart(cart);
	}
	return cart;
}

/**
 * 移除游客购物车中的商品
 */
export function removeFromGuestCart(skuId) {
	let cart = getGuestCart();
	cart = cart.filter(item => item.skuId !== skuId);
	setGuestCart(cart);
	return cart;
}

/**
 * 清空游客购物车
 */
export function clearGuestCart() {
	localStorage.removeItem(GUEST_CART_KEY);
}

/**
 * 获取游客购物车数量
 */
export function getGuestCartCount() {
	const cart = getGuestCart();
	return cart.reduce((total, item) => total + item.quantity, 0);
}

// ===================== 游客登录信息管理 =====================

/**
 * 保存游客注册后的登录信息（保持15天）
 */
export function saveGuestLoginInfo(data) {
	const info = {
		username: data.username,
		memberId: data.memberId,
		exists: data.exists || false
	};
	localStorage.setItem(GUEST_INFO_KEY, JSON.stringify(info));
	localStorage.setItem(GUEST_LOGIN_EXPIRE_KEY, String(Date.now() + LOGIN_EXPIRE_MS));
	if (data.password) {
		// 临时密码仅保存一次（用于自动登录），建议用完即清
		localStorage.setItem('BIZ_GUEST_TEMP_PWD', data.password);
	}
}

/**
 * 获取游客登录信息（检查是否过期）
 */
export function getGuestLoginInfo() {
	const expireStr = localStorage.getItem(GUEST_LOGIN_EXPIRE_KEY);
	if (expireStr && Date.now() > Number(expireStr)) {
		clearGuestLoginInfo();
		return null;
	}
	try {
		const data = localStorage.getItem(GUEST_INFO_KEY);
		return data ? JSON.parse(data) : null;
	} catch (e) {
		return null;
	}
}

/**
 * 清除游客登录信息
 */
export function clearGuestLoginInfo() {
	localStorage.removeItem(GUEST_INFO_KEY);
	localStorage.removeItem(GUEST_LOGIN_EXPIRE_KEY);
	localStorage.removeItem('BIZ_GUEST_TEMP_PWD');
}

/**
 * 检查是否有游客登录信息
 */
export function hasGuestLogin() {
	return getGuestLoginInfo() !== null;
}
